export const CartActionTypes = {
    ADD_TO_CART: 'ADD_TO_CART',
    DECREASE_ITEM_IN_CART: 'DECREASE_ITEM_IN_CART',
    INCREASE_ITEM_IN_CART: 'INCREASE_ITEM_IN_CART'
}